<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-info-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2C11.848 2 2 11.848 2 24s9.848 22 22 22 22-9.848 22-22S36.152 2 24 2zm2.012 18.025a1 1 0 00-1-1h-3.397a1 1 0 00-1 1V22a1 1 0 001 1h.377l.002 8.01h-1.989a1 1 0 00-1 1v1.975a1 1 0 001 1h8.018a1 1 0 001-1V32.01a1 1 0 00-1-1h-2.008l-.003-10.985zM25.57 14a1 1 0 00-1-1h-2.125a1 1 0 00-1 1v2.002a1 1 0 001 1h2.125a1 1 0 001-1V14z"/></svg>
</template>
<script>

export default {
  name: 'IconInfoFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
